import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';
import AdminDashboard from './pages/AdminDashboard';
import Sidebar from './components/Sidebar';
import WhatsAppBtn from './components/WhatsAppBtn';
import Admissions from './pages/Admissions';
import Login from './pages/Login';
import Courses from './pages/Courses';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import InstallPopup from './components/InstallPopup';
import './App.css';
import Notices from './pages/Notices';
import Duas from './pages/Duas';

const ConditionalWhatsApp = () => {
  const location = useLocation();
  
  // If the path starts with "/admin", do NOT show the button
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  // Otherwise, show the button
  return <WhatsAppBtn />;
};

const ConditionalInstall = () => {
  const location = useLocation();
  // If we are on ANY admin page, return null (hide it)
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  // Otherwise, show the popup
  return <InstallPopup />;
};

function App() {
  // --- FRONTEND WAKE-UP TRICK ---
  useEffect(() => {
    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const API_URL = `${BASE_URL}/api`;
    

    console.log("Pinging server to wake up...");
    axios.get(`${API_URL}/courses`)
      .then(() => console.log("Server is awake and ready!"))
      .catch((err) => console.log("Server is waking up...", err));
  }, []);
  // ----------------------------------
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Sidebar />
          <Routes>
            {/* PUBLIC ROUTES */}
            <Route path="/" element={<Home />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/courses" element={<Courses />} />
            
            {/* --- "/login" to "/admin/login" --- */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<Login />} />
            {/* ----------------------------------------------------- */}

            {/* PROTECTED ADMIN ROUTE */}
            <Route element={<PrivateRoute />}>
               <Route path="/admin" element={<AdminDashboard />} />
               <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Route>

            <Route path="/notices" element={<Notices />} />
            <Route path="/duas" element={<Duas />} />

          </Routes>
          <ConditionalInstall />
          <ConditionalWhatsApp />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;